<template>
  <div class="sidebar-logo-container">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link a-c" to="/">
        <h1 style="font-size: 22px" class="sidebar-title">{{ closeTitle }}</h1>
      </router-link>
      <router-link v-else key="expand" :class="['sidebar-logo-link',{'a-c': !logo}]" to="/">
        <template v-if="logo">
          <img :src="logo" class="sidebar-logo">
          <img :src="imgSplit" class="sidebar-split-logo m-l-10 m-r-10">
        </template>
        <h1 :class="['sidebar-title', logo ? '' : 'remove-logo']">{{ openTitle }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { projectConfig } from '@U/projectConfig'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      openTitle: 'Tracking System',
      closeTitle: 'T S',
      logo: projectConfig.barLogoUrl,
      imgSplit: require('@/assets/image/split.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  /* text-align: center; */
  overflow: hidden;
  .sidebar-split-logo{
    width: 2px;
    height: 30px;
    vertical-align: middle;
  }

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      /* width: 35px; */
      height: 37px;
      margin-left: 9px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #0a71ba;
      font-weight: 600;
      line-height: 56px;
      font-size: 16px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      &.remove-logo {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
